<form [formGroup]="datosUbicacionForm">
  <div class="data-form-cont">
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Dirección</mat-label>
        <input matInput formControlName="residenciaDireccion">
        <mat-error *ngIf="datosUbicacionForm.get('residenciaDireccion').invalid">{{getErrorMessage('residenciaDireccion')}}</mat-error>
      </mat-form-field>
    </div>
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Barrio</mat-label>
        <input matInput formControlName="residenciaBarrio" required>
        <mat-error *ngIf="datosUbicacionForm.get('residenciaBarrio').invalid">{{getErrorMessage('residenciaBarrio')}}</mat-error>
      </mat-form-field>
    </div>
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Ciudad</mat-label>
        <mat-select formControlName="residenciaCiudadID" required>
          <mat-option *ngFor="let ciudad of ciudades$ | async as ciudades" [value]="ciudad['id']">
            {{ciudad['nombre']}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="data-form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Teléfono fijo</mat-label>
        <input matInput formControlName="residenciaTelefono" required>
        <mat-error *ngIf="datosUbicacionForm.get('residenciaTelefono').invalid">{{getErrorMessage('residenciaTelefono')}}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</form>
